
/*
 * Convenience methods for common Event handling scenarios;
 *
 * @usage: <element onMouseDown={preventDefault}/>;
 */

export function preventDefault(event) {
  return (event.nativeEvent || event).preventDefault();
}

export function stopPropagation(event) {
  return (event.nativeEvent || event).stopPropagation();
}

export function stopImmediatePropagation(event) {
  return (event.nativeEvent || event).stopImmediatePropagation();
}
